module.exports = __webpack_public_path__ + "img/valtellina.be1392d9.jpg";